// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"a4a87874","453":"46984791","900":"54003c1b"}[chunkId] + ".chunk.js";
};